import React from 'react';
import PropTypes from 'prop-types';
import { QUESTION_TYPE } from 'constants/constants';

import { Spinner } from 'reactstrap';
import Ordering from './Ordering';
import FreeText from './FreeText';
import MultipleChoice from './MultipleChoice';
import DragAndDrop from './DragAndDrop';
import { getThemeColor } from 'store/settings';
import { useSelector } from 'react-redux';
import SurveyRating from './surveyRating';
import SurveyScaling from './surveyScaling';
import AssignmentType from './assignment-type';

const QuestionType = ({
  question,
  type,
  componentFooter,
  list,
  setList,
  isLoading,
  isSync,
  test,
  multi,
  setMulti,
  setQuestionArray,
  questionArray,
  handleOnchange
}) => {
  const themeStatus = useSelector(getThemeColor);

  const renderQuestion = () => {
    if (type === QUESTION_TYPE.ORDERING) {
      return (
        <Ordering
          question={question}
          list={list}
          setList={setList}
          test={test}
        />
      );
    }

    if (type === QUESTION_TYPE.FREETEXT) {
      return (
        <FreeText
          test={test}
          question={question}
          setQuestionArray={setQuestionArray}
          questionArray={questionArray}
          handleOnchange={handleOnchange}
          isSync={isSync}
        />
      );
    }
    if (type === QUESTION_TYPE.RATING)
      return (
        <SurveyRating
          question={question}
          defaultValues={question?.data}
          questionArray={questionArray}
          setQuestionArray={setQuestionArray}
        />
      );
    if (type === QUESTION_TYPE.SCALING)
      return (
        <SurveyScaling
          defaultValues={
            question?.data?.length ? question?.data[0] : question?.data
          }
          questionArray={questionArray}
          setQuestionArray={setQuestionArray}
          question={question}
        />
      );
    if (type === QUESTION_TYPE.MTC) {
      return (
        <MultipleChoice
          questionArray={questionArray}
          setQuestionArray={setQuestionArray}
          question={question}
          test={test}
          multi={multi}
          setMulti={setMulti}
        />
      );
    }

    if (type === QUESTION_TYPE.DRAGDROP) {
      return (
        <DragAndDrop
          question={question}
          key={list?.length}
          list={list}
          test={test}
          setList={setList}
        />
      );
    }
    // if (type === QUESTION_TYPE.ASSIGNMENT) {
    //   return <AssignmentType />;
    // }
  };

  return (
    <>
      {!isLoading ? (
        renderQuestion()
      ) : (
        <div className="m-3 flexRow justify-content-center">
          <Spinner style={{ color: `${themeStatus}` }} />
        </div>
      )}
      {componentFooter}
    </>
  );
};

QuestionType.defaultProps = {
  isLoading: false,
};

QuestionType.propTypes = {
  type: PropTypes.string.isRequired,
  componentFooter: PropTypes.any,
  list: PropTypes.array,
  setList: PropTypes.func,
  question: PropTypes.any.isRequired,
};

export default QuestionType;
